import { useState } from 'react';
import cancelLicenseApi from '../api/cancelLicense';

export default function useCancelLicense(
    subscriptionId: number,
    onCancelled: () => void,
    onError: (message: string) => void
) {
    const [isCancelling, setIsCancelling] = useState(false);
    const [isConfirmCancellationDialogOpen, setIsConfirmCancellationDialogOpen] = useState(false);

    const openConfirmCancellationDialog = () => setIsConfirmCancellationDialogOpen(true);
    const closeConfirmCancellationDialog = () => setIsConfirmCancellationDialogOpen(false);

    const cancelLicense = async () => {
        setIsConfirmCancellationDialogOpen(false);
        setIsCancelling(true);

        const response = await cancelLicenseApi(subscriptionId);
        if (response?.status && response.status !== 200) {
            onError('Failed to cancel subscription.');
        } else {
            onCancelled();
        }

        setIsCancelling(false);
    };

    return {
        isCancelling,
        isConfirmCancellationDialogOpen,
        openConfirmCancellationDialog,
        closeConfirmCancellationDialog,
        cancelLicense,
    };
}
